import React from 'react';
import { notify } from 'reapop';
import { connect } from 'react-redux';


const defaultOpts = {
  status: 'default',
  allowHTML: true,
  position: 'tc',
  dismissAfter: 3000,
};

// info: #349ef3
// error: #f5311d
// success: #4dc657
// warning: #f5aa0a
export const withNotify = (Component) => {
  class Hoc extends React.Component {
    constructor(props) {
      super(props);

      this.notify = this.notify.bind(this);
      this.notifyError = this.notifyError.bind(this);
      this.notifyInfo = this.notifyInfo.bind(this);
    }

    _notify = (opts = {}) => {
      this.props.notify({ ...defaultOpts, ...opts });
    }

    notify = (message, opts = {}) => {
      this._notify({ ...opts, message });
    }

    notifyError = (message, opts = {}) => {
      this._notify({ ...opts, message, status: 'error' });
    }

    notifyInfo = (message, opts = {}) => {
      this._notify({ ...opts, message, status: 'info' });
    }

    notifySuccess = (message, opts = {}) => {
      this._notify({ ...opts, message, status: 'success' });
    }

    notifyWarning = (message, opts = {}) => {
      this._notify({ ...opts, message, status: 'warning' });
    }

    render() {
      return (
        <Component
          {...this.props}
          notify={this.notify}
          notifyError={this.notifyError}
          notifyInfo={this.notifyInfo}
          notifySuccess={this.notifySuccess}
          notifyWarning={this.notifyWarning}
        />
      );
    }
  }

  return connect(null, { notify })(Hoc);
};



// WEBPACK FOOTER //
// ./src/components/hocs/withNotify.js